/**
 * D4F SHIPPING TIMELINE - DYNAMIC CALCULATION
 * Datei: assets/d4f-shipping-timeline.js
 * - Berechnet Produktions- und Lieferzeiten
 * - Berücksichtigt Werktage und Feiertage
 * - PLZ-basierter Versandkosten-Rechner
 */
(function () {
  const section = document.querySelector('.d4f-shipping-timeline-section');
  if (!section) return;

  // Settings aus data-Attributen lesen
  const settings = {
    productionMin: parseInt(section.dataset.productionMin) || 2,
    productionMax: parseInt(section.dataset.productionMax) || 3,
    productionDays: section.dataset.productionDays || 'mo-fr',
    shippingMin: parseInt(section.dataset.shippingMin) || 1,
    shippingMax: parseInt(section.dataset.shippingMax) || 2,
    shippingDays: section.dataset.shippingDays || 'mo-fr',
    cutoffHour: parseInt(section.dataset.cutoffHour) || 14,
    holidays: parseHolidays(section.dataset.holidays),
  };

  console.log('[D4F Timeline] Settings:', settings);

  // Initialize
  calculateTimeline();
  initShippingCalculator();

  /**
   * TIMELINE BERECHNUNG
   */
  function calculateTimeline() {
    const now = new Date();
    const currentHour = now.getHours();

    // Bestelldatum ermitteln
    let orderDate = new Date(now);
    if (currentHour >= settings.cutoffHour) {
      // Nach Bestellschluss → nächster Tag
      orderDate = addDays(orderDate, 1);
    }

    // Produktionsende berechnen
    const productionEndMin = addWorkingDays(
      new Date(orderDate),
      settings.productionMin,
      settings.productionDays,
      settings.holidays
    );
    const productionEndMax = addWorkingDays(
      new Date(orderDate),
      settings.productionMax,
      settings.productionDays,
      settings.holidays
    );

    // Lieferdatum berechnen
    const deliveryDateMin = addWorkingDays(
      new Date(productionEndMin),
      settings.shippingMin,
      settings.shippingDays,
      settings.holidays
    );
    const deliveryDateMax = addWorkingDays(
      new Date(productionEndMax),
      settings.shippingMax,
      settings.shippingDays,
      settings.holidays
    );

    console.log('[D4F Timeline] Calculated dates:', {
      order: orderDate,
      productionMin: productionEndMin,
      productionMax: productionEndMax,
      deliveryMin: deliveryDateMin,
      deliveryMax: deliveryDateMax,
    });

    // UI aktualisieren
    updateTimelineUI({
      order: orderDate,
      productionMin: productionEndMin,
      productionMax: productionEndMax,
      deliveryMin: deliveryDateMin,
      deliveryMax: deliveryDateMax,
    });
  }

  /**
   * TIMELINE UI AKTUALISIEREN
   */
  function updateTimelineUI(dates) {
    const locale = document.documentElement.lang || 'de-DE';

    // Bestelldatum
    const orderDateEl = document.querySelector('[data-timeline-date="order"]');
    if (orderDateEl) {
      orderDateEl.textContent = formatDate(dates.order, locale);
    }

    // Versandbereit
    const readyDateEl = document.querySelector('[data-timeline-date="ready"]');
    if (readyDateEl) {
      if (isSameDay(dates.productionMin, dates.productionMax)) {
        readyDateEl.textContent = formatDate(dates.productionMax, locale);
      } else {
        readyDateEl.textContent = formatDateRange(dates.productionMin, dates.productionMax, locale);
      }
    }

    // Geliefert
    const deliveredDateEl = document.querySelector('[data-timeline-date="delivered"]');
    if (deliveredDateEl) {
      if (isSameDay(dates.deliveryMin, dates.deliveryMax)) {
        deliveredDateEl.textContent = formatDate(dates.deliveryMax, locale);
      } else {
        deliveredDateEl.textContent = formatDateRange(dates.deliveryMin, dates.deliveryMax, locale);
      }
    }
  }

  /**
   * VERSANDKOSTEN-RECHNER
   */
  function initShippingCalculator() {
    const calcButton = document.getElementById('d4f-calc-shipping');
    const zipInput = document.getElementById('d4f-shipping-zip');
    const resultContainer = document.getElementById('d4f-shipping-result');
    const priceEl = document.getElementById('d4f-shipping-price');

    if (!calcButton || !zipInput || !resultContainer || !priceEl) return;

    calcButton.addEventListener('click', function () {
      const zip = zipInput.value.trim();

      if (!zip || zip.length !== 5 || !/^\d{5}$/.test(zip)) {
        alert('Bitte gib eine gültige 5-stellige Postleitzahl ein.');
        return;
      }

      // Versandkosten berechnen (vereinfachtes System)
      const shippingCost = calculateShippingCost(zip);

      // Ergebnis anzeigen
      priceEl.textContent = shippingCost === 0 
        ? 'Kostenlos' 
        : `€ ${shippingCost.toFixed(2).replace('.', ',')}`;

      resultContainer.style.display = 'flex';

      // Animation
      resultContainer.style.animation = 'none';
      setTimeout(() => {
        resultContainer.style.animation = 'slideIn 0.4s ease';
      }, 10);
    });

    // Enter-Taste Support
    zipInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        calcButton.click();
      }
    });
  }

  /**
   * VERSANDKOSTEN BERECHNEN (basierend auf PLZ)
   */
  function calculateShippingCost(zip) {
    const zipNum = parseInt(zip);

    // Deutschland PLZ-Bereiche
    // 00000-99999 = Deutschland
    // Vereinfachte Logik - kann erweitert werden
    
    if (zipNum >= 0 && zipNum <= 99999) {
      // Deutschland
      // Beispiel: Kostenlos ab 50€, sonst 4,90€
      // In der Praxis würde man hier den Warenkorbwert prüfen
      return 4.90;
    } else {
      // Andere Länder (sollte nicht vorkommen bei deutscher PLZ)
      return 9.90;
    }
  }

  /**
   * HELPER FUNCTIONS
   */

  function parseHolidays(holidaysString) {
    if (!holidaysString) return [];
    return holidaysString.split(',').map(d => d.trim()).filter(Boolean);
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function addWorkingDays(startDate, workingDays, workDaysType, holidays) {
    let date = new Date(startDate);
    let daysAdded = 0;

    while (daysAdded < workingDays) {
      date = addDays(date, 1);

      // Prüfe ob es ein Arbeitstag ist
      if (isWorkingDay(date, workDaysType, holidays)) {
        daysAdded++;
      }
    }

    return date;
  }

  function isWorkingDay(date, workDaysType, holidays) {
    const dayOfWeek = date.getDay(); // 0 = Sonntag, 6 = Samstag

    // Prüfe Feiertage
    const dateStr = formatDateISO(date);
    if (holidays.includes(dateStr)) {
      return false;
    }

    // Prüfe Wochentag
    switch (workDaysType) {
      case 'mo-fr':
        return dayOfWeek >= 1 && dayOfWeek <= 5;
      case 'mo-sa':
        return dayOfWeek >= 1 && dayOfWeek <= 6;
      case 'mo-so':
        return true;
      default:
        return dayOfWeek >= 1 && dayOfWeek <= 5;
    }
  }

  function formatDate(date, locale) {
    return date.toLocaleDateString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  function formatDateRange(dateMin, dateMax, locale) {
    const minDay = dateMin.getDate();
    const maxDay = dateMax.getDate();
    const minMonth = dateMin.getMonth();
    const maxMonth = dateMax.getMonth();
    const minYear = dateMin.getFullYear();
    const maxYear = dateMax.getFullYear();

    // Gleicher Monat und Jahr
    if (minMonth === maxMonth && minYear === maxYear) {
      const month = dateMin.toLocaleDateString(locale, { month: '2-digit' });
      return `${minDay.toString().padStart(2, '0')}.${month}. - ${maxDay.toString().padStart(2, '0')}.${month}.${minYear}`;
    }

    // Verschiedene Monate
    return `${formatDate(dateMin, locale)} - ${formatDate(dateMax, locale)}`;
  }

  function formatDateISO(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function isSameDay(date1, date2) {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }

  // Live-Update alle 60 Sekunden (falls Bestellschluss überschritten wird)
  setInterval(() => {
    calculateTimeline();
  }, 60000);
})();